import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';

import { TextInput } from 'evee-ui-common/components/base';

import useEditProfile from 'store/modules/profile/hooks/useEditProfile';

import styles from './styles';

const AboutUser = ({ value, edit, loading, classes, ...rest }) => {
  const { onFieldChanged } = useEditProfile();

  const skeletonJsx = (
    <>
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </>
  );

  const aboutJsx = (
    <Box className={classes.preWrapContainer} {...rest}>
      {edit ? (
        <TextInput
          multiline
          value={value}
          label=""
          InputProps={{ rows: 4 }}
          onChange={(v) => onFieldChanged('about', v)}
        />
      ) : (
        value && <Typography variant="body1" className={classes.container}>{value}</Typography>
      )}
    </Box>
  );

  return (
    <>
      <Typography gutterBottom variant="h4">
        About
      </Typography>
      {loading ? skeletonJsx : aboutJsx}
    </>
  );
};

AboutUser.propTypes = {
  value: PropTypes.string,
  edit: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    input: PropTypes.string.isRequired,
  }).isRequired,
};

AboutUser.defaultProps = {
  value: '',
  edit: false,
};

export default withStyles(styles)(AboutUser);
